import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import I18n from "../../../../base/i18n.js.jsx";

import ProgressBar from "../../../../base/components/progress_bar.js";
import Tooltip from "../../../../base/components/tooltip.js";

import MoneyFormatter from "../../../../utils/money_formatter.js";

const useProgressCellContentStyles = makeStyles(theme => ({
  root: {

  },
  legend: {
    fontSize: "14px"
  },
  description: {
    color: theme.palette.white,
    padding: "5px"
  },
  row: {
    color: theme.palette.white,
    marginBottom: "5px",
    "&:last-child": {
      marginBottom: "0px"
    }
  },
  label: {
    fontSize: "14px",
    fontWeight: theme.typography.fontWeightBold
  },
  value: {
    fontSize: "13px",
  }
  
}));

const ProjectProgressCell = (props) => {
  const { project } = props;
  const classes = useProgressCellContentStyles();

  const { cost, amountLeftToCollect, amountOfInvestments, amountOfOwnCapital, amountOfBankCredit } = project;
  if(!cost || !amountOfInvestments || !amountOfOwnCapital || !amountOfBankCredit || !amountLeftToCollect) {
    return <React.Fragment />
  }
  const needInvestments = cost - amountOfOwnCapital - amountOfBankCredit;

  if(!cost || !amountLeftToCollect) {
    return <React.Fragment>
      { "-" }
    </React.Fragment>
  }

  return (
    <div className = { classes.root } >
      <Tooltip content = { 
        <div className = { classes.description } >
          <div className = { classes.row }>
            <span className = { classes.label } >
              { `${I18n.t("component.project_progress_cell.own_capital")}: ` }
            </span>
            <span className = { classes.value } >
              { `${MoneyFormatter.format(amountOfOwnCapital)} ${I18n.t("currency.euro")}` }
            </span>
          </div>
          <div className = { classes.row }>
            <span className = { classes.label } >
              { `${I18n.t("component.project_progress_cell.bank_credit")}: ` }
            </span>
            <span className = { classes.value } >
              { `${MoneyFormatter.format(amountOfBankCredit)} ${I18n.t("currency.euro")}` }
            </span>
          </div>
          <div className = { classes.row }>
            <span className = { classes.label } >
              { `${I18n.t("component.project_progress_cell.investments")}: ` }
            </span>
            <span className = { classes.value } >
              { `${MoneyFormatter.format(amountOfInvestments)} ${I18n.t("currency.euro")}` }
            </span>
          </div>
        </div>
      } >
        <ProgressBar curValue = { amountOfInvestments } maxValue = { needInvestments } />
      </Tooltip>
      <div className = { classes.legend } >
        { `${MoneyFormatter.format(amountOfInvestments)} / ${MoneyFormatter.format(needInvestments)} ${I18n.t("currency.euro")}` }
      </div>
    </div>
  )
}

export default ProjectProgressCell;